// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","buttons":"App_buttons__qFKEr","table":"App_table__riwNn","centerContainer":"App_centerContainer__5CB6w"};